import { DeviceStatus } from '../../domain/enums/device-status';
import { Registration } from '../../domain/models';
import { Device } from '../../domain/models/distribution/device';
import { RegistrationViewModel } from './registration.view-model';

export class DeviceViewModel {
    public id: string;
    public name: string;
    public appVersion: string;
    public started: Date;
    public finished: Date;
    public status: DeviceStatus;
    public batteryPercentage: number;
    public distributionProgress: number;
    public distributionProgressEarly: number;
    public distributionProgressLate: number;
    public modifiedAt: Date;
    public registrations: RegistrationViewModel[];
    public deviceColor: string;

    constructor();
    constructor(json: any);
    constructor(json?: Device) {
        if (json) {
            this.id = json.imei;
            this.name = json.imei;
            this.appVersion = json.appVersion;
            this.started = json.started;
            this.finished = json.finished;
            this.status = json.status;
            this.batteryPercentage = json.batteryPercentage;
            this.distributionProgress = json.percentageCompleted;
            this.distributionProgressEarly = json.percentageCompletedEarly;
            this.distributionProgressLate = json.percentageCompletedLate;
            this.modifiedAt = json.modifiedAt;
            this.registrations = json.registrations.map((registration: Registration) => new RegistrationViewModel(registration))
                .sort((registrationOne: Registration, registrationTwo: Registration) => registrationOne.startTime > registrationTwo.startTime ? 1 : -1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/view-models/device.view-model.ts